import { NavLink } from 'react-router-dom';
import { cn } from '../lib/utils';

const ITEMS = [
  { to: '/', label: 'Home', icon: '⚽' },
  { to: '/today', label: 'Today', icon: '📅' },
  { to: '/bracket', label: 'Bracket', icon: '🏆' },
  { to: '/leagues', label: 'Leagues', icon: '👥' },
  { to: '/profile', label: 'Profile', icon: '👤' },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-30 bg-bg-darker/95 backdrop-blur-md border-t border-border-base">
      <div className="mx-auto max-w-md grid grid-cols-5">
        {ITEMS.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 py-3 transition-colors',
                isActive ? 'text-trophy-gold' : 'text-text-faint',
              )
            }
          >
            <span className="text-xl leading-none">{it.icon}</span>
            <span className="font-display-alt text-[10px] uppercase tracking-widest">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
